<div class="template3">
    <div class="bonus-reissue__block my-3">
        <div class="row">
            <div class="col-md-4 download-template__label">
                {{'ticketing-system.Download template to update or create tickets here' |translate | translateKey}}
            </div>
            <div class="col-md-4 download-template">
                <span
                    (click)="downloadDocument('/test/CSP_BonusReissue_Upload.csv')">
                    <i class="fa text-primary fa-download pr-10"
                        title="{{'ticketing-system.download '|translate | translateKey}}"></i>
                    {{'ticketing-system.Download Template' |translate | translateKey}}
                </span>
            </div>
        </div>
        <div class="row pt-5">
            <div class="col-md-4 upload-label">
                {{'ticketing-system.Upload completed file to update or create tickets here' |translate | translateKey}}
            </div>
            <div class="col-md-8">
                <label tabindex="0" (keyup.enter)="fileSelect.click()" for="attachFile"
                    class="btn btn-secondary choose-file__button"
                    title="{{'ticketing-system.Choose File'|translate | translateKey}}">
                    <span
                        aria-hidden="true">{{'ticketing-system.Choose File'|translate | translateKey |uppercase}}</span>
                    <input #fileSelect type="file" id="attachFile" ng2FileSelect [uploader]="uploader"
                        (change)="onSelectFile($event.target.files)" role="file" aria-label="browse"
                        style="display: none;" accept=".csv">
                </label>
                <label class="pl-2" *ngFor="let item of uploader.queue">
                    {{item.file.name }}
                    <i class="fa fa-trash pl-2" (click)="item.remove();fileSelect.value='';fileUploadedResponse=null;"
                        title="{{'ticketing-system.Delete'|translate | translateKey}}"></i>
                </label>
            </div>
        </div>

        <div class="row pt-5">
            <div class="col-md-4"></div>
            <div class="col-md-8">
                <div ng2FileDrop (fileOver)="onSelectFile($event)" [uploader]="uploader"
                    class="text-center well drop-file">
                    {{'ticketing-system.Drop file here...' |translate | translateKey}}
                </div>
            </div>
        </div>
        <div class="row pb-10" *ngIf="fileUploadedResponse && fileUploadedResponse.validations && fileUploadedResponse.validations.length && !fileUploadedResponse.uuid">
            <div class="col-md-4"></div>
            <div class="col-md-8" *ngFor="let error of fileUploadedResponse.validations">
                <span class="error">{{error.message}}</span>
            </div>
        </div>
        <div class="row text-right pr-15">
            <button tabindex="0" type="button" (click)="uploadBonusReissueTicketsFile();"
                [attr.disabled]="!uploader || !uploader?.queue?.length ? '':null" class="btn blue-button">
                {{'ticketing-system.Upload' |translate | uppercase}}
            </button>
        </div>
    </div>
    <modal #uploadResponseTemplate>
        <modal-header>
            <div class="color-blue">{{'customer-service.File Upload Response' |translate | translateKey | uppercase}}
            </div>
        </modal-header>
        <modal-content>
            <div class="col-md-12" *ngIf="fileUploadedResponse">
                <div class="row">
                    <div class="col-md-4 text-bold">{{'ticketing-system.Total Processed'|translate | translateKey}}:
                    </div>
                    <div class="col-md-8">{{fileUploadedResponse.totalProcessed}}</div>
                </div>
                <div class="row pt-10">
                    <div class="col-md-4 text-bold">{{'ticketing-system.Total Succeeded'|translate | translateKey}}:
                    </div>
                    <div class="col-md-8">{{fileUploadedResponse.totalSucceeded}}</div>
                </div>
                <div class="row pt-10">
                    <div class="col-md-4 text-bold">{{'ticketing-system.Total Failed'|translate | translateKey}}:</div>
                    <div class="col-md-8">{{fileUploadedResponse.totalFailed}}</div>
                </div>
                <div class="row pt-10">
                    <div class="col-md-4 text-bold">
                        {{'ticketing-system.Download Response'|translate | translateKey}}:
                    </div>
                    <div class="col-md-8">
                        <a class="pr-10" target="_blank" [href]="fileUploadedResponse.url">
                            <i class="fa text-primary fa-download pr-10"
                                title="{{'ticketing-system.download '|translate | translateKey}}"></i>
                        </a>
                    </div>
                </div>
                <div class="text-right">
                    <button class="btn blue-button text-right" tabindex="0" type="button" (click)="closePopup()">
                        {{'order.Close' |translate |translateKey|uppercase}}
                    </button>
                </div>
            </div>
        </modal-content>
    </modal>
</div>



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/bonus-reissue-tickets.component.html